/* Display-only expiry timer. No network, source discovery or automated publishing. */
(function () {
  'use strict';
  var timer;
  function expire() {
    window.clearTimeout(timer);
    var now = Date.now();
    var nextExpiry = Infinity;
    document.querySelectorAll('[data-uth-breaking-expiry]').forEach(function (badge) {
      var expiry = Number(badge.dataset.uthBreakingExpiry) * 1000;
      if (!Number.isFinite(expiry) || now >= expiry) badge.remove();
      else nextExpiry = Math.min(nextExpiry, expiry);
    });
    if (Number.isFinite(nextExpiry)) {
      timer = window.setTimeout(expire, Math.max(1, Math.min(nextExpiry - now, 2147483647)));
    }
  }
  expire();
  document.addEventListener('visibilitychange', expire);
  window.addEventListener('pageshow', expire);
})();

/* Progressive public-link sharing. No SDK, tracking, network request or draft URL sharing. */
(function () {
  'use strict';
  var PUBLIC_HOSTS = ['uthnation.com', 'www.uthnation.com'];
  function publicUrl(value) {
    try {
      var url = new URL(value);
      if (url.protocol !== 'https:' || PUBLIC_HOSTS.indexOf(url.hostname) < 0 || url.port || url.username || url.password || url.search || url.hash) return null;
      if (!/^\/blogs\/the-wire\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname)) return null;
      return url.href;
    } catch (_) { return null; }
  }
  function publicContext() {
    var current = new URL(window.location.href);
    if (current.protocol !== 'https:' || PUBLIC_HOSTS.indexOf(current.hostname) < 0 || current.port) return false;
    if (window.Shopify && window.Shopify.designMode) return false;
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') return false;
    return !Array.from(current.searchParams.keys()).some(function (key) {
      return /^(preview_theme_id|preview_script_id|preview_key|_fd|pb)$/i.test(key);
    });
  }
  function init() {
    document.querySelectorAll('[data-uth-wire-share]').forEach(function (container) {
      if (container.dataset.uthShareReady === 'true') return;
      container.dataset.uthShareReady = 'true';
      var copy = container.querySelector('[data-uth-share-copy]');
      var status = container.querySelector('[data-uth-share-status]');
      var fallback = container.querySelector('[data-uth-share-fallback]');
      var input = container.querySelector('[data-uth-share-url]');
      var template = container.querySelector('[data-uth-share-native-template]');
      var email = container.querySelector('[data-uth-share-email]');
      var url = publicUrl(container.dataset.shareUrl);
      var title = (container.dataset.shareTitle || '').replace(/[\r\n]+/g, ' ').trim();
      if (!copy || !status) return;
      if (container.dataset.sharePublic !== 'true' || !publicContext() || !url || !title || !fallback || !input) {
        copy.disabled = true;
        status.textContent = 'Available after publication';
        container.dataset.sharePublic = 'false';
        delete container.dataset.shareUrl;
        delete container.dataset.shareTitle;
        if (fallback) fallback.remove();
        if (email) email.remove();
        if (template) template.remove();
        return;
      }
      // These are server-approved canonical values, never location.href or query text.
      input.value = url;
      if (email) email.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url);
      copy.disabled = false;
      function selectLink(message) {
        fallback.open = true;
        input.focus();
        input.select();
        status.textContent = message + ' The story link is selected below; copy it using your device’s copy command.';
      }
      copy.addEventListener('click', async function () {
        copy.disabled = true;
        try {
          if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(url);
          status.textContent = 'Link copied.';
        } catch (_) {
          selectLink('Automatic copying is unavailable.');
        } finally {
          copy.disabled = false;
        }
      });
      var canShare = typeof navigator.share === 'function';
      try {
        if (canShare && typeof navigator.canShare === 'function') canShare = navigator.canShare({ title: title, url: url });
      } catch (_) { canShare = false; }
      if (canShare && template) {
        var nativeButton = template.content.firstElementChild.cloneNode(true);
        template.replaceWith(nativeButton);
        nativeButton.addEventListener('click', async function () {
          nativeButton.disabled = true;
          try {
            await navigator.share({ title: title, url: url });
            // Share-sheet completion does not establish that a recipient received it.
            status.textContent = '';
          } catch (error) {
            if (!error || error.name !== 'AbortError') selectLink('Sharing is unavailable.');
          } finally {
            nativeButton.disabled = false;
          }
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
